export default "__VITE_ASSET__Dz55_vmz__"